import { useEffect } from "react"
import api from "../../../utils/axios"
import { PixInfo } from "../types"

interface PixStatusContent {
    pix?: PixInfo | null
    validated?: number | null
}

interface Resp {
    success: boolean
    status: string
    content: PixStatusContent
}

/**
 * Faz polling de /pix/status (5 s) enquanto houver um PIX ativo e não expirado.
 * Ao concluir (CONCLUIDA), chama onResponse com o `content` (traz `validated`).
 * Generalizado para o modelo de pares: recebe o PixInfo do par, não um Device.
 */
function useAwaitStatusPix(
    pix: PixInfo | null | undefined,
    onResponse: (data: PixStatusContent) => void
) {
    useEffect(() => {
        if (!pix) return

        let cancelled = false

        const fetchStatusPix = async (txid: string, expiresAt: number) => {
            let status: string | null = null
            let lastPoll = Date.now()

            while (
                status !== "CONCLUIDA" &&
                !cancelled &&
                expiresAt > lastPoll
            ) {
                if (expiresAt && Date.now() > expiresAt) break
                await new Promise((resolve) => setTimeout(resolve, 5000))
                try {
                    const res = await api.post<Resp>("/pix/status", { txid })
                    status = res.data.status
                    if (status === "CONCLUIDA") {
                        onResponse(res.data.content)
                        break
                    }
                    lastPoll = Date.now()
                } catch (error) {
                    break
                }
            }
        }

        fetchStatusPix(pix.txid, pix.expiresAt)

        return () => {
            cancelled = true
        }
        // onResponse omitido de propósito (ver componente pai): re-executar só ao trocar de PIX.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pix])
}

export default useAwaitStatusPix
